import React from 'react';
import { NavLink } from 'react-router-dom';
import { FaUserMd } from 'react-icons/fa';
import { HiOutlineSquares2X2 } from "react-icons/hi2";
import { IoHelpCircleOutline } from "react-icons/io5";

const Sidebar = ({ isOpen }) => {
  return (
    <div className={`sidebar bg-white border-end ${isOpen ? 'open' : ''}`} style={{ width: '240px' }}>
      <div className="d-flex flex-column h-100 py-3">
        <ul className="nav flex-column">
          <li className="nav-item mb-1">
            <NavLink 
              to="/dashboard" 
              className={({ isActive }) => `nav-link d-flex align-items-center gap-2 py-2 px-3 ${isActive ? 'btn-danger  text-white' : 'text-secondary'}`}
              style={{ borderRadius: '4px', margin: '0 8px' }}
            >
              <HiOutlineSquares2X2 style={{ fontSize: '18px' }} />
              <span className='form-labels'>Dashboard</span>
            </NavLink>
          </li>
          <li className="nav-item mb-1 ">
            <NavLink 
              to="/doctors" 
              className={({ isActive }) => `nav-link d-flex align-items-center gap-2 py-2 px-3 ${isActive ? 'btn-danger  text-white' : 'text-secondary'}`}
              style={{ borderRadius: '4px', margin: '0 8px' }}
            >
              <FaUserMd style={{ fontSize: '18px' }} />
              <span className='form-labels'>Doctors</span>
            </NavLink>
          </li>
          <li className="nav-item mb-1">
            <NavLink 
              to="/supports" 
              className={({ isActive }) => `nav-link d-flex align-items-center gap-2 py-2 px-3 ${isActive ? 'btn-danger  text-white' : 'text-secondary'}`}
              style={{ borderRadius: '4px', margin: '0 8px' }}
            >
              <IoHelpCircleOutline  style={{ fontSize: '18px' }} />
              <span className='form-labels'>Support</span>
            </NavLink>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default Sidebar; 